import styled from 'styled-components';
import { Link } from 'gatsby';

const colorTheme = {
  secondary: '#589fe5',
  red: '#de6c7f',
  green: '#41c6bf',
};

const ButtonBackgroundColors = {
  primary: '#333',
  secondary: '#1b7bdd',
  outline: '#333',
  secondaryOutline: 'transparent',
  red: '#ce445b',
  green: '#1ba39c',
  black: 'transparent',
  secondarytransparent: 'transparent',
  secondaryWhite: 'transparent',
  redWhite: 'transparent',
  redSecondary: '#fff',
};

const ButtonTextColors = {
  primary: '#333',
  secondary: '#fff',
  outline: '#fff',
  red: '#fff',
  green: '#fff',
  black: '#000',
  secondarytransparent: '#1b7bdd',
  secondaryWhite: '#fff',
  redWhite: '#fff',
  greentransparent: '#1ba39c',
  redSecondary: '#ce445b',
};

const ButtonBorderColors = {
  primary: 'transparent',
  secondary: 'transparent',
  outline: '#fff',
  secondaryOutline: '#fff',
  red: 'transparent',
  green: 'transparent',
  black: '#000',
  secondarytransparent: '#1b7bdd',
  secondaryWhite: '#fff',
  redWhite: '#fff',
  redSecondary: '#ce445b',
  greentransparent: '#1ba39c',
};

const ButtonHoverBorderColors = {
  primary: 'transparent',
  secondary: 'transparent',
  outline: 'transparent',
  secondaryOutline: 'transparent',
  red: 'transparent',
  green: 'transparent',
  black: '#000',
  secondarytransparent: '#1b7bdd',
  secondaryWhite: '#1b7bdd',
  redWhite: '#ce445b',
  redSecondary: '#fff',
  greentransparent: '#1ba39c',
};

const ButtonHoverColors = {
  primary: '#717171',
  secondary: '#165ca3',
  outline: '#717171',
  secondaryOutline: '#589fe5',
  red: '#98293b',
  redSecondary: '#ce445b',
  green: '#1a746f',
  black: '#000',
  secondarytransparent: '#1b7bdd',
  secondaryWhite: '#1b7bdd',
  redWhite: '#ce445b',
  greentransparent: '#1ba39c',
};

export const Button = styled(Link).attrs((props) => ({ stylevariant: props.stylevariant }))`
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  user-select: none;
  font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : 'DINMediumAlternate '};
  border: 1px solid ${({ stylevariant }) => ButtonBorderColors[stylevariant]};
  line-height: 1.5;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
  border-radius: 20px;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? 'normal' : '1.29px')};
  padding: 10px 1.5rem;
  min-width: 215px;
  text-align: center;
  text-transform: uppercase;
  background-color: ${({ stylevariant }) => ButtonBackgroundColors[stylevariant]};
  transition: 0.3s;
  color: ${({ stylevariant }) => ButtonTextColors[stylevariant]};

  &:hover {
    background-color: ${({ stylevariant }) => ButtonHoverColors[stylevariant]};
    border: 1px solid ${({ stylevariant }) => ButtonHoverBorderColors[stylevariant]};
    color: #fff;
  }

  &.btn-outline {
    background: none;
    border: 1px solid ${({ stylevariant }) => ButtonBackgroundColors[stylevariant]};
    color: ${({ stylevariant }) => ButtonBackgroundColors[stylevariant]};

    &:hover {
      background-color: ${({ stylevariant }) => ButtonBackgroundColors[stylevariant]};
      color: #fff;
    }
  }

  span {
    font-family: inherit;
  }

  @media (max-width: 1199px) {
    min-width: 215px;
    padding: 10px 20px;
  }

  &.footer_subscribebutton {
    border: 1px solid #fff;
    color: #fff;
    font-family: ${({ dir }) =>
    dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : 'URWDINBold, sans-serif'};

    &:hover {
      background-color: ${({ color }) => colorTheme[color]};
      border-color: ${({ color }) => colorTheme[color]};
    }
    @media (max-width: 767px) {
      padding-top: ${({ dir }) => dir === 'rtl' ? '5px' : '8px'};
      height: 32px;
    }
  }

  &.btn_eventcta {
    @media (max-width: 1199.98px) {
      min-width: 215px;
      padding: 10px 20px;
    }
  }
  &.cta-btn {
    @media (max-width: 1199.98px) {
      min-width: 215px;
      padding: 10px 20px;
    }
  }
  &.google_map_btn {
    &:focus {
      background-color: #1b7bdd;
      color: #fff;
    }
  }
`;

export const ButtonInRight = styled.div`
  display: flex;
  justify-content: end;
  padding-top: 30px;

  @media (max-width: 767px) {
    justify-content: center;
  }

  &.tab_tansportbutton {
    padding-top: 0;

    @media (max-width: 991.98px) {
      justify-content: space-between;
    }

    @media (max-width: 767.98px) {
      justify-content: center;
    }
  }
`;

export const ButtonDiv = styled.div`
  text-align: center;

  &.btn_cta {
    margin: 1rem 0 3rem;
  }

  &.text-left {
    text-align: left;
  }

  &.new_developmentbutton {
    &[dir='ltr'] {
      text-align: left;
    }
    &[dir='rtl'] {
      text-align: right;
    }
    @media (max-width: 768px) {
      display: none;
    }
  }

  &.new_developmentbutton_sv {
    display: none;

    @media (max-width: 768px) {
      display: block;
      text-align: center;
      margin-top: 2rem;
    }
  }

  &.btn_freezonecta {
    margin: 3rem 0 0;
    @media (max-width: 575.98px) {
      margin: 2rem 0 0;
    }
  }
  &.btn_breadcrumn {
    @media (max-width: 767.98px) {
      text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
      margin-top: 1.5rem !important;
    }
  }
`;

export const UrlButton = styled.div`
  @media (max-width: 992px) {
    margin-bottom: 2rem;
  }
`;
